import type { JArray, JObject, JString } from '../types';

export interface CreateRoutingGuideValidationSchema extends JObject {
  type: 'object';
  properties: {
    name: JString;
    countryCode: JString;
    transportationGroupId: JString;
    transportationMode: JString;
    cargoType: JString;
    carriers?: JArray;
    collaborators?: JArray;
  };
  required: ['name', 'countryCode', 'transportationGroupId', 'transportationMode', 'cargoType'];
}

export type FieldsForRoutingGuideCreate = keyof CreateRoutingGuideValidationSchema['properties'];

export const ROUTING_GUIDE_LABELS: {
  [Key in FieldsForRoutingGuideCreate]?: string | Record<string, string>;
} = {
  cargoType: 'Cargo type',
  countryCode: 'Country',
  name: 'Routing Guide Name',
  transportationGroupId: 'Transportation Group',
  transportationMode: 'Transportation Mode',
} as const;
